import React, { Component } from "react";
import Rating from 'react-rating';
import ReactSVG from 'react-svg';

class storySectionitem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storyData:{},
      isShow:true
    };
  }
  componentDidMount(){
    try {
      this.setState({
        storyData: this.props.data,
        isShow:true,
      })
    } catch (error) {
      this.setState({
        storyData: {},
        isShow:false
      })
    }
 
  }



  render() {
    return (
      <div className="comment-package-area-item">
        <div className="skin-type-hello-title" style={{paddingTop:"1em",marginBottom:0,color:"#fff"}}>{this.state.storyData.title}’s Story</div>
        <div className="comment-package-area-item-text">
            <div className="text-Symbol">“</div>
            <div className="text-comment">{this.state.storyData.quote}</div>
            <div style={{marginTop:"2.33em",lineHeight: 1}}>
                <Rating emptySymbol={<ReactSVG path="/images/common/star-red.svg" wrapperClassName="svg-wrapper" style={{ width: '30px', height: '30px', marginRight:'9px'  }}/>}   readonly={true} fullSymbol={<ReactSVG path="/images/common/star-red.svg" wrapperClassName="svg-wrapper selected" style={{ width: '30px', height: '30px', marginRight:'7px' }}/>} initialRating={5} />
            </div>
        </div>
        <div className="h4-title font-white" style={{marginTop:'1.96em'}}>Recommended products for him</div>
        <div className="comment-package-bottom-info">
          {
            this.state.storyData.rightImg ? 
              <div className="left-conten">
                  <div className="left-conten-img-text">
                    <div className={ this.state.storyData.title == "Asiana" ? "conten-img-area" : this.state.storyData.title == 'Kai' ? "kai-conten-img-area": "" } >
                        <img src={this.state.storyData.letImg}/>
                    </div>
                      <div className="left-conten-text">Before</div>
                  </div>
                  <div className="left-conten-img-text">
                  <div className={ this.state.storyData.title == "Asiana" ? "conten-img-area" : this.state.storyData.title == 'Kai' ? "kai-conten-img-area": "" } >
                            <img src={this.state.storyData.rightImg}/>
                        </div>
                      <div className="left-conten-text">After</div>
                  </div>
              </div>:
              <div className="left-conten">
                  <div className="left-conten-img-text" style={{margin:'auto'}}>
                      <img src={this.state.storyData.letImg}/>
                  </div>
              </div>
            }

            <div className="centen-conten">
                <div className="centen-conten-goods">
                    <div className="centen-conten-goods-number">1</div>
                    <div className="centen-conten-goods-img"><img src={this.state.storyData.img1}/></div>
                    <div className="centen-conten-goods-type h4-title">{this.state.storyData.img1Text}</div>
                </div>
                <div className="centen-conten-goods">
                    <div className="centen-conten-goods-number">2</div>
                    <div className="centen-conten-goods-img"><img src={this.state.storyData.img2}/></div>
                    <div className="centen-conten-goods-type h4-title">{this.state.storyData.img2Text}</div>
                </div>
                <div className="centen-conten-goods">
                    <div className="centen-conten-goods-number">3</div>
                    <div className="centen-conten-goods-img"><img className={ this.state.storyData.title == "Sydney Adel" ?  "img-upc" : this.state.storyData.img3Text == "Moisturize" ? "moisturize-img-styl" : "" } src={this.state.storyData.img3}/></div>
                    <div className="centen-conten-goods-type h4-title">{this.state.storyData.img3Text}</div>
                </div>
            </div>
  
            <div className="right-conten">
                <div className="right-conten-top-item" style={{marginBottom:'4.91em'}}>
                    <div className="right-conten-top-item-icon skinConcerns-sty">
                        <img className="skin-concerns-incon-1" src="../images/plan/story/SkinConcerns_1.svg"/>
                        <img className="skin-concerns-incon-2" src="../images/plan/story/SkinConcerns_2.svg"/>
                    </div>
                    <div className="right-conten-top-item-skin-concerns">
                        <p className="h4-title font-white" style={{marginBottom:'0.46em'}}>Skin concerns</p>
                        <p className="h5-text font-white">{this.state.storyData.skinConcerns}</p>
                    </div>
                </div>

                <div className="right-conten-top-item" >
                    <div className="right-conten-top-item-icon">
                        <img src="../images/plan/story/waterDrop.svg"/>
                    </div>
                    <div className="right-conten-top-item-skin-concerns">
                        <p className="h4-title font-white" style={{textAlign:'left', marginBottom:'0.46em'}}>Skin type</p>
                        <p className="h5-text font-white" style={{textAlign:'left'}}>{this.state.storyData.skinType}</p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default storySectionitem;



// WEBPACK FOOTER //
// ./src/views/AA/plan/storySectionitem.js